"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapObject = exports.mapProp = void 0;
// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
const get = (obj, path, defaultValue = undefined) => {
    const travel = (regexp) => String.prototype.split
        .call(path, regexp)
        .filter(Boolean)
        .reduce((res, key) => res !== null && res !== undefined ? res[key] : res, obj);
    const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
    return result === undefined || result === obj ? defaultValue : result;
};
/**
 * @param  {string[]} keys
 * @param  {{[key:string]:any}} obj
 * @returns string
 */
const mapProp = (keys, obj) => {
    const response = keys
        .map((key) => {
        const hit = get(obj, key);
        if (typeof hit === 'object') {
            return JSON.stringify(hit);
        }
        return hit;
    })
        .filter((item) => !!item)
        .join(',');
    return response !== '' ? response : undefined;
};
exports.mapProp = mapProp;
/**
 * @param  {{[key:string]:string[]}} properties
 * @param  {{[key:string]:any}} obj
 * @returns string
 */
const mapObject = (properties, obj) => {
    const mappings = {};
    if (properties) {
        return Object.keys(properties).reduce((accumulator, key) => {
            accumulator[key] = exports.mapProp(properties[key], obj);
            return accumulator;
        }, mappings);
    }
    return mappings;
};
exports.mapObject = mapObject;
